var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar2 = function SvgDefaultAvatar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 55h11.3c1.8 0 1.6.7 2.8.7 1.8 0 3.2-4.5 3.2-7 0-1.3-.4-2.4-1.3-2.4-.6 0-1 .8-1.4 1.8-.5 1.2-.8 2-1.1 2.3-.6.7-3.4.8-6.9.8h-5.4c2.2-1.9 5.1-4.4 8.5-7.8 2.8-2.8 5.2-6.3 5.2-10.3 0-4.8-3.4-8.6-8.9-8.6-3.9 0-7 1.9-8.9 4.8-.9 1.3-1.3 2.5-1.3 3.4 0 .7.5 1.3 1.1 1.3.6 0 1-.5 1.7-1.6 1.4-2.4 3.4-4.1 6.1-4.1 3.2 0 5.2 2.2 5.2 5.4 0 2.8-1.6 5.2-4.1 8.1-2.1 2.5-5.3 5.7-9.6 9.7-.6.6-.9 1.1-.9 1.8 0 .8.6 1.6 1.8 1.6 1.1.2 2 .1 2.9.1z"
  })));
};
export default SvgDefaultAvatar2;